import {
  IRouteDetails,
  IIconTitleAsProps,
  IRouteDetailsDataBlobProps,
  ITextAsProps,
  ITitleTextAsProps,
  IRouteDetailsKeyValueProps,
  RouteDetailsTableProps,
} from '../../../sp-types/routeDetailsType';

export const mockRouteDetailsTableColumns = ['Product', 'Start Period', 'End Period', 'Maintenance', 'USD Per Ton'];
export const mockRouteDetailsTableRowsData = [
  ['CONTAINER FREIGHT(FBX13)BALTIC FUT', '08/2023', '08/2023', '550 USD', '$11'],
  ['CONTAINER FREIGHT(FBX13)BALTIC FUT', '09/2023', '10/2023', '500 USD', '$10'],
  ['CONTAINER FREIGHT(FBX13)BALTIC FUT', '11/2023', '05/2026', '400 USD', '$10'],
];

export const DEFAULT_ROUTE_DETAILS_ICON = './assets/icons/gray-bg/route.svg';

export const routeDetailsMockData: IRouteDetails = {
  id: '1',
  routeDetails: [
    {
      type: 'RouteMainTitle',
      data: { title: 'Main Title' } as IIconTitleAsProps,
    },
    {
      type: 'RouteDetailsDataBlob',
      data: {
        icon: 'location',
        title: 'Location Data',
        dataList: [
          { title: 'Latitude', value: '40.7128 N' },
          { title: 'Longitude', value: '74.0060 W' },
        ],
        isAlert: false,
      } as IRouteDetailsDataBlobProps,
      offset: 1,
    },
    {
      type: 'RouteDetailsPlainText',
      data: { text: 'This is a plain text component with some sample text.' } as ITextAsProps,
      offset: 1,
    },
    {
      type: 'RouteDetailsTextBox',
      data: { title: 'Text Box Title', text: 'This is the text inside the text box component.' } as ITitleTextAsProps,
    },
    {
      type: 'RouteDetailsKeyValue',
      data: {
        data: [
          { label: 'Key 1', value: 'Value 1' },
          { label: 'Key 2', value: 'Value 2' },
        ],
      } as IRouteDetailsKeyValueProps,
    },
    {
      type: 'RouteDetailsSubTitle',
      data: { title: 'Sub Title' } as IIconTitleAsProps,
    },
    {
      type: 'RouteDetailsTable',
      data: {
        columns: ['Column 1', 'Column 2'],
        rowsData: [
          { ['Column 1']: '1', ['Column 2']: '2' },
          { ['Column 1']: '3', ['Column 2']: '3' },
        ],
      } as RouteDetailsTableProps,
    },
  ],
};
